// extracted by mini-css-extract-plugin
module.exports = {"filter":"styles_filter__1L5hV"};